import Decimal from 'decimal.js';
import type { DisposalDetail, FifoResult } from './types';
import { taxYearUtc } from './fiTaxYear';

export function filterFifoByTaxYear(result: FifoResult, year: number): FifoResult {
  const details = result.details.filter((d) => taxYearUtc(d.ts) === year);
  let totalGainEur = new Decimal(0);
  let totalLossEur = new Decimal(0);
  for (const d of details) {
    const g = d.chosenGainEur ?? d.gainEur;
    if (g.gte(0)) totalGainEur = totalGainEur.plus(g);
    else totalLossEur = totalLossEur.plus(g.abs());
  }
  return {
    details,
    totalGainEur,
    totalLossEur,
    warnings: result.warnings,
  };
}

export function disposalDetailsForYear(
  details: DisposalDetail[],
  year: number
): DisposalDetail[] {
  return details.filter((d) => taxYearUtc(d.ts) === year);
}
